// import ModalForm from "./Form";
import PackagesTableForm from "./PackagesTableForm";
import { PACKAGES_HISTORY } from "../../../../../../../Config/ApiUrl";
import { DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
    components: { PackagesTableForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            Endpoint:
                PACKAGES_HISTORY + "?clc_id_number=" + this.value?.clc_id_number,
            tableId: "packages-table",
            formId: "packages-table-form",
            rowData: {},
            tableColumns: [
                {
                    title: "Packages Name",
                    type: "text",
                    key: "package_name",
                },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "PackagesTable",
                url:
                    PACKAGES_HISTORY +
                    "?clc_id_number=" +
                    this.value?.clc_id_number,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t("view"),
                        icon: "eye",
                        type: "page",
                        component: "packages-table-detail",
                        modalId: "packages-table-detail",
                    },
                ],
                // filters: [
                // ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 3,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {},
};
